import apiClient from './api';

export default {
    async getPendampings(params = {}) {
        try {
            const response = await apiClient.get('/pendampings', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching pendampings:', error);
            throw error;
        }
    },

    async getPendamping(id) {
        try {
            const response = await apiClient.get(`/pendampings/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching pendamping ${id}:`, error);
            throw error;
        }
    },

    async createPendamping(data) {
        return apiClient.post('/pendampings', data);
    },

    async updatePendamping(id, data) {
        return apiClient.put(`/pendampings/${id}`, data);
    },

    async deletePendamping(id) {
        return apiClient.delete(`/pendampings/${id}`);
    }
};
